module.exports = __webpack_public_path__ + "static/Negotiation-d591cd0b025a1725dc8df84e7b41876e.png";